import script from "./InstructionAmplooPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionAmplooPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionAmplooPage.vue?vue&type=style&index=0&id=45277442&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45277442"]])

export default __exports__